module.exports = __webpack_public_path__ + "assets/img/txt-professionals-08.048be5a0.svg";